import React from 'react';
import { LogoMascot, Wordmark } from './BrandArtwork';
import { navLinks } from '../data/site';
export function SiteFooter() {
  return <footer className="border-t border-ink/10 bg-cream" data-id="element-114" data-mp="3r8rikunn8i0h">
      <div className="mx-auto max-w-content px-5 pb-10 pt-14 md:px-8 md:pt-16 lg:px-10" data-id="element-115" data-mp="3mh11m5u7aw03">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12" data-id="element-116" data-mp="3hiprdtzzujhc">
          <div className="md:col-span-6" data-id="element-117" data-mp="3hgddpt19qva3">
            <div className="inline-flex items-center gap-[4px]" data-id="element-118" data-mp="3dhe3pu0ok8bs">
              <LogoMascot className="h-8 w-auto shrink-0 md:h-10" knockoutId="footer-mascot-knockout" data-id="element-119" data-mp="3dei503h0dfma" />
              <Wordmark className="h-8 w-auto md:h-10" knockoutId="footer-wordmark-knockout" data-id="element-120" data-mp="33jq4aqs4qcna" />
            </div>
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ink/75" data-id="element-121" data-mp="2yl542rcvnsyu">
              A boutique app studio building original apps for learning, life and play.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-6 md:grid-cols-2" data-id="element-122" data-mp="wsqq23dgf8np">
            <nav aria-label="Footer" data-id="element-123" data-mp="15ptvkr0nxovd">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-124" data-mp="15syaojfo250t">
                Sections
              </h2>
              <ul className="mt-4 space-y-1" data-id="element-125" data-mp="vt7bi4g5v1ue">
                {navLinks.map(link => <li key={link.href} data-id="element-126" data-mp="10rikkcymt8bk">
                    <a href={link.href} className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-127" data-mp="10sjzwtmokgz3">
                      {link.label}
                    </a>
                  </li>)}
                <li data-id="element-128" data-mp="1eppclcgwge3b">
                  <a href="#top" className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-129" data-mp="1jqd4e0cycyyl">
                    Back to top
                  </a>
                </li>
              </ul>
            </nav>

            <div data-id="element-130" data-mp="2m1uwppsj53vd">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-131" data-mp="2m2e9ks3bp22j">
                Studio
              </h2>
              <ul className="mt-4 space-y-3 text-[15px] text-ink/80" data-id="element-132" data-mp="2d27ux2vw1w1s">
                <li data-id="element-133" data-mp="2d0eqzvcntpxh">blackcometlabs.io</li>
                <li data-id="element-134" data-mp="283o9d3l7im9y">Learning · Lifestyle · Gaming</li>
                <li data-id="element-135" data-mp="282vccuc1vb50">Built for U.S. users</li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-12 text-xs font-medium text-ink/65" data-id="element-136" data-mp="2364xgabzell6">
          © {new Date().getFullYear()} Black Comet Labs. Small studio. Big apps.
        </p>
      </div>
    </footer>;
}